import { useEffect } from 'react';

export const useSEO = ({ title, description, image, keywords } = {}) => {
  useEffect(() => {
    const siteName = 'BDShop — বাংলাদেশের সেরা অনলাইন শপ';
    const fullTitle = title ? `${title} | BDShop` : siteName;

    document.title = fullTitle;

    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', description || 'Shop electronics, fashion, food & more. bKash, Nagad, Cash on Delivery available. বাংলাদেশের সেরা অনলাইন শপিং প্ল্যাটফর্ম।');
    setMeta('keywords', keywords || 'online shopping bangladesh, bdshop, bkash payment, electronics, fashion, food delivery');
    setMeta('robots', 'index, follow');

    // Open Graph
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description || '', true);
    setMeta('og:image', image || '/og-image.jpg', true);
    setMeta('og:type', 'website', true);
    setMeta('og:site_name', 'BDShop', true);

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description || '');
    if (image) setMeta('twitter:image', image);
  }, [title, description, image, keywords]);
};
